import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCustomInputValidatorDirective } from './fi-custom-input-validator.directive';

@NgModule({
    declarations: [FiCustomInputValidatorDirective],
    imports: [CommonModule],
    exports: [FiCustomInputValidatorDirective],
})
export class FiCustomInputValidatorModule {}
